module.exports = __webpack_public_path__ + "static/media/Program13.1feee9eb.jpg";